import React, { FC } from 'react';
import { General } from '../sections/General';
import { LookAndFeel } from '../sections/LookAndFeel';
import { ResizeAndCrop } from '../sections/ResizeAndCrop';
import { ImageOverlay } from '../sections/ImageOverlay';
import { TextOverlays } from '../sections/TextOverlays';
import { Export } from '../sections/Export';

export const SettingsTab: FC = () => (
  <div>
    <General />
    <LookAndFeel />
    <ResizeAndCrop />
    <ImageOverlay />
    <TextOverlays />
    <Export />
  </div>
);
